import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { AdSpacePhotoInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  photoToUpdate: AdSpacePhotoInterface | null;
  setPhotoToUpdate: React.Dispatch<React.SetStateAction<AdSpacePhotoInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const AdSpacePhotosUpdateDialog: React.FC<Props> = ({
  open,
  photoToUpdate,
  setPhotoToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update Ad Space Photo</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="Ad Space ID"
        type="number"
        value={photoToUpdate?.adSpaceId ?? ''}
        onChange={e => setPhotoToUpdate(p => p ? { ...p, adSpaceId: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Photo URL"
        value={photoToUpdate?.photoUrl ?? ''}
        onChange={e => setPhotoToUpdate(p => p ? { ...p, photoUrl: e.target.value } : p)}
        fullWidth
        margin="dense"
        required
      />
      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={photoToUpdate?.active !== undefined ? (photoToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setPhotoToUpdate(p => p ? { ...p, active: e.target.value === 'yes' } : p)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);
